// Add or remove image filenames here to update the carousel
// Just drop new images into public/backgrounds/ and add their filenames to this array
// You can optionally specify mobile positioning (desktop always uses "center center")
// Mobile position examples: "center top", "center 30%", "left center", "right 40%", etc.
export const backgroundImages = [
  {
    filename: "hilton-pool.webp",
    mobilePosition: "65% center"
  },
  {
    filename: "Chiang-Mai.webp",
    mobilePosition: "60% center"
  },
  {
    filename: "koh-pha-ngan.webp",
    mobilePosition: "70% center"
  },
  {
    filename: "eastin-grand-hotel.webp",
    mobilePosition: "65% center"
  },
];
